export default __webpack_public_path__ + "static/media/InfinitiBG.c8c7700d.jpg";